<template>
  <a-typography>
    <a-typography-title>星汉未来</a-typography-title>
    <a-typography-paragraph>
      让计算像电一样随需使用
    </a-typography-paragraph>
  </a-typography>
</template>

<script lang="ts" type="text/tsx">
export default {
  name: 'main'
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

.ant-typography {
  padding: 5px 10px;
  color: @color_white;
}
</style>